<template>
    <div
        class="timeline"
        :class="{ asPreview }"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        asPreview: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .timeline {
    position: relative;
    padding-top: 56px;
    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -1.5px;
        width: 3px;
        height: 100%;
        background-color: #eeeeee;
    }
}

.asPreview {
    padding-top: 0;
    &:before {
        left: 35px;
    }
}
</style>
